import { useEffect, useState } from 'react';
import { fetchCourses, fetchDropdownsInformation, createCourse } from 'Api/coursesPage';

const useFetch = setIsLoading => {
  const [courses, setCourses] = useState([]);
  const [name, setName] = useState('');
  const [authors, setAuthors] = useState([]);
  const [author, setAuthor] = useState(null);
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState(null);
  const [terminals, setTerminals] = useState([]);
  const [terminal, setTerminal] = useState(null);
  const [isDraft, setIsDraft] = useState(null);
  const [isCard, setIscard] = useState(true);

  useEffect(() => {
    const newCategory = category === '' ? null : category;
    const newTerminal = terminal === '' ? null : terminal;
    const newAuthor = author === '' ? null : author;
    const newIsDraft = isDraft === '' ? null : isDraft;

    fetchCourses({
      category: newCategory,
      name,
      author: newAuthor,
      terminal: newTerminal,
      isDraft: newIsDraft,
    }).then(data => {
      setCourses(data.courses);
      setIsLoading(false);
    });
  }, [category, name, author, terminal, isDraft]);

  useEffect(() => {
    fetchDropdownsInformation().then(data => {
      setCategories(data.categories);
      setAuthors(data.authors);
      setTerminals(data.terminals);
    });
  }, []);

  return {
    courses,
    setCourses,
    categories,
    setCategory,
    setName,
    setIscard,
    isCard,
    authors,
    setAuthor,
    setTerminal,
    terminals,
    setIsDraft,
    createCourse,
  };
};

export default useFetch;
